import React ,{useEffect, useState} from 'react';
import { loadCancelledRX, loadCancelledRXDetails } from '../../Services/loadOrder';
import { useNavigate } from 'react-router-dom';
import MenuBar from './MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import "../../assets/css/home.css";
import toast, {Toaster} from 'react-hot-toast';
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';

const PartiallyCancelledGrid = () => {
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const [names, setNames] = useState([]);
    const [selectedName, setSelectedName] = useState("");
    const [searchText, setSearchText] = useState("");
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const user = JSON.parse(localStorage.getItem('user'));
    
    useEffect(() => {
        const searchFields = columns.map(col => ({
          label: col.headerName,
          field: col.searchField || col.field
        }));
        setNames(searchFields);
    }, []);
    
    const handleSearch = async () => {
        if (!selectedName || !searchText) {
          toast.error("Please select a value and enter text to search.");
          return;
        }
    
        const user = JSON.parse(localStorage.getItem('user'));
        const pharmacyId = user?.pharmacyId;
        const userId = user?.userId;
    
        if (!pharmacyId || !userId) {
          toast.error("Missing pharmacy or user info. Please login again.");
          navigate('/error-page');
          return;
        }
    
        setSearchLoading(true);
        try {
          const orderResponse = await loadCancelledRX(pharmacyId, 2, "", selectedName, searchText, userId);
          if (orderResponse.success && Array.isArray(orderResponse.data)) {
    
            const formattedRows = orderResponse?.filter.map((item, index) => ({
              id: index + 1,
              MemberID: item.MemberID,
              LastName: item.LastName,
              FirstName: item.FirstName,
              MedStartDate: item.MedStartDate,
              MedEndDate: "", // Optional field
              CancelDate: item.CancelDate,
              CancelledBy: item.CancelledBy,
              Contract: item.Contract,
              taskId: item.Taskid,
              pharmacyId,
              userId,
              FormattedAuthNo: item.FormattedAuthNo,
            }));
            setRows(formattedRows);
          } else {
            setRows([]);
            toast.error("No data found for the search.");
          }
        } catch (error) {
          navigate('/error-page');
          toast.error("Error searching cost share details.");
        } finally {
          setSearchLoading(false);
        }
    };
      
    const columns = [{ field: 'MemberID', headerName: 'Member ID', flex:1, headerClassName: 'pink-header' },
    { field: 'LastName', headerName: 'Last Name', flex:1, headerClassName: 'pink-header' },
    { field: 'FirstName', headerName: 'First Name', flex:1, headerClassName: 'pink-header' },
    { field: 'MedStartDate', headerName: 'Med Start Date',flex:1, headerClassName: 'pink-header' },
    { field: 'CancelDate', headerName: 'Cancel Date', flex:1, headerClassName: 'pink-header' },  
    { field: 'CancelledBy', headerName:'Cancelled By',flex:1, headerClassName: 'pink-header' },
    { field: 'Contract', headerName: 'Contract',flex:1, headerClassName: 'pink-header',
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
       
    ];
    
    useEffect(() =>{
        const fetchData = async () => {
            const user = JSON.parse(localStorage.getItem('user'));
            const pharmacyId = user?.pharmacyId;
            const userId = user?.userId;
            if (!pharmacyId) return;

            const orderResponse = await loadCancelledRX(pharmacyId,2, "","","", userId);
            if (orderResponse.success) {
                const taskDetails = orderResponse?.data || [];
                console.log("Raw order response:", orderResponse);
                console.log("TaskDetails:", orderResponse?.data);

                const formattedRows = taskDetails.map((item, index) => ({
                    id: index + 1,
                    MemberID: item.MemberID,
                    LastName: item.LastName,
                    FirstName: item.FirstName,
                    MedStartDate: item.MedStartDate? new Date(item.MedStartDate).toLocaleDateString() : "",
                    MedEndDate: "", // Optional field
                    CancelDate: item.CancelDate ? new Date(item.CancelDate).toLocaleDateString() : "",
                    CancelledBy: item.CancelledBy,
                    Contract: item.Contract,
                    taskId: item.Taskid,
                    pharmacyId,
                    userId,
                    FormattedAuthNo: item.FormattedAuthNo,
                }));

                console.log("Formatted rows:", formattedRows);
                setRows(formattedRows);
            } else {
                toast.error("No TaskDetails found.");
            }

            setLoading(false);
        };

        fetchData();
    },[]);

    const handleRowClick = async (params) => {
        const row = params.row;

        const contract = row.Contract;
        const taskId = row.taskId;
        const pharmacyId = row.pharmacyId;
        const userId = row.userId;
        const authNo = row.FormattedAuthNo;
        const memberId = row.MemberID;
        console.log("Calling loadCancelledRXDetails with:", { authNo, contract, pharmacyId, userId, memberId, taskId });

        if (!contract || !taskId || !pharmacyId || !userId) {
            toast.error("Missing required task or user data.");
            navigate('/error-page');
            return;
        }

        try {
            const rxResponse = await loadCancelledRXDetails(pharmacyId, memberId, authNo, taskId, contract);
            console.log("Prescription details response:", rxResponse?.data);

            if (Array.isArray(rxResponse?.data) && rxResponse.data.length > 0) {
                navigate('/entirelly-cancelled-details', {
                    state: {
                        taskId,
                        contract,
                        pharmacyId,
                        userId,
                        memberId,
                        authNo,
                        source: 'partial',
                        cancelledDetails: rxResponse.data // Pass the details if needed
                    }
                });
            } else {
                toast.error("No prescription data found.");
            }
        } catch (err) {
            console.error("Failed to load prescription details:", err);
            toast.error("Error loading prescription details.");
            navigate('/error-page');
        }
    };

    return (
        <div>
            <MenuBar/>
            <Toaster position='top-right'/>
            <div className='top-page-option'>
                <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
                    <a 
                        href="#/home" 
                        style={{
                            textDecoration: 'none',
                            color: '#ec088c',
                            display: 'inline-flex',
                            alignItems: 'center'
                        }}
                    >
                        <ChevronLeft color='#ec088c' size={18} />
                        <span style={{ marginLeft: '5px' }}>Back</span>
                    </a>
                </div>
            
                <div
                    className='top-page-option-name'
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginTop: '10px',
                        flexWrap: 'wrap'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontWeight: 400, fontSize: 18 }}>Cancelled Orders</span>
                        <ChevronRight color='#ec088c' size={18} />
                        <span style={{ fontWeight: 400, fontSize: 18 }}>Partially Cancelled Order</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto', marginRight:'7.7%' }}>
                        <FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
                            <InputLabel sx={{ fontFamily: 'Calibri', marginBottom: '10px', background: '#fff', color: 'black', fontSize: '12px' }}>
                                --Select--
                            </InputLabel>
                            <Select
                                value={selectedName}
                                onChange={(e) => setSelectedName(e.target.value)}
                                label="Select"
                                sx={{
                                    fontFamily: 'Calibri',
                                    fontSize: '12px',
                                    borderRadius: '15px',
                                    border: '1px solid rgba(236, 151, 202)',
                                    height: '30px',
                                    boxShadow: 'none',
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#ec008c',
                                        boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#ec008c',
                                    },
                                }}
                            >
                                <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                    --Select--
                                </MenuItem>
                                {names.map((item, idx) => (
                                    <MenuItem key={idx} value={item.field} sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <input
                            type="text"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
                            style={{ padding: '5px 5px', borderRadius: '15px', border: '1px solid rgba(236, 151, 202)', outline: 'none',
                                transition: 'all 0.3s ease'
                            }}
                            onFocus={(e) => {
                                e.target.style.border = '1px solid #ec008c';
                                e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
                            }}
                            onBlur={(e) => {
                                e.target.style.border = '1px solid rgba(236, 151, 202)';
                                e.target.style.boxShadow = '0 1px 2px rgba(236, 151, 202)';
                            }}
                        />
                        <button
                            onClick={handleSearch}
                            disabled={searchLoading}
                            style={{ padding: '6px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
                        >
                            {searchLoading ? <>
                                Searching&nbsp;&nbsp;
                                <CircularProgress size={15} sx={{ color: '#fff' }} />
                            </> : 'Search'}
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            style={{ padding: '5px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
                        >
                            View All
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ height: 'auto', width: '85%', margin: 'auto' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[10, 25, 50]}
                    disableSelectionOnClick
                    onRowClick={handleRowClick}
                    sx={{
                        fontSize: '12px',
                        fontFamily: 'Segoe UI',
                        '& .pink-header': {
                            color: '#fff',
                            backgroundColor: '#ec008c',
                            fontWeight: 'bold',
                            whiteSpace: 'normal !important',
                            wordBreak: 'breakWord !important',
                            overflowWrap: 'breakWord !important',
                            lineHeight: '1.3 !important',
                            textAlign: 'center',
                            padding: '8px 2px !important',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#f5f5f5 !important',
                            cursor: 'pointer',
                        },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                            outline: 'none !important',
                            boxShadow: 'none !important',
                            backgroundColor: 'none !important',  
                        },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none !important',
                            boxShadow: 'none !important',
                        },
                    }}
                />
            </div>

            {(loading || searchLoading) && (
                <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              border: '6px solid #f3f3f3',
              borderTop: '6px solid #EC088C',
              borderRadius: '50%',
              width: 48,
              height: 48,
              animation: 'spin 1s linear infinite'
            }} />
            <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
            <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
          </div>
            )}
        </div>
    );
};

export default PartiallyCancelledGrid;